import { makeStyles } from "tss-react/mui";
import { MiPlaceholderList } from "@miplatform/components";
import { mdiFormatListBulleted } from "@mdi/js";
import { Box } from "@mui/material";

export function EmptySearchResults({
  icon = mdiFormatListBulleted,
  text = "No search results.",
  helperText = "",
  actions = [],
}) {
  const { classes } = useStyles();

  return (
    <Box className={classes.emptyListContainer}>
      <MiPlaceholderList
        icon={icon}
        text={text}
        helperText={helperText}
        actions={actions}
      />
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  emptyListContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
